module.exports = __webpack_public_path__ + "static/img/logoDefault.3800f2d4.png";